import CreatableSelect from 'react-select/creatable'


export default class CreatablePowerSelect extends CreatableSelect<any> { }